'use client';
import { createPreset } from "../createPreset.js";
import { caption1StrongerClassNames, useCaption1StrongerStyles } from "./useCaption1Stronger.styles.js";
/**
 * Text preset component for the Caption1Stronger typography variant
 */ export const Caption1Stronger = createPreset({
    useStyles: useCaption1StrongerStyles,
    className: caption1StrongerClassNames.root,
    displayName: 'Caption1Stronger'
});
